import React from 'react';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import { cn } from '@/lib/utils';
import { getColor } from '@/lib/theme-utils';

function SocialLinks({ socialLinks, setSocialLinks }) {
  // Predefined platforms in the expected order with their icons
  const socialPlatforms = [
    { 
      name: 'Facebook', 
      id: 'facebook',
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/35b22c7aaa7c26e0c91476866dc87dc6302cf44148069c77abed3e2791cc421c?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803'
    },
    { 
      name: 'X', 
      id: 'twitter',
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/da441f9343ad38233bbd1ea68a32c7e9c2d23e31a97eda50a4561b46ec9b35cf?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803'
    },
    { 
      name: 'Instagram', 
      id: 'instagram',
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/e1dbf7b85c7a1a00404be20aa07a52a4f89166205c03b6dd65080912271438a0?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803'
    },
    { 
      name: 'Youtube', 
      id: 'youtube',
      icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/471aa963ae72065b8da9442c9f000e2efa0eb2bdfbffd74aa6dbb82901226296?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803'
    }
  ];

  // Update the URL for the specific platform
  const handleLinkChange = (index, value) => {
    const updatedLinks = [...socialLinks];
    updatedLinks[index] = value; // Update the specific URL
    setSocialLinks(updatedLinks); // Update state
  };

  return (
    <form className="flex flex-col gap-4 md:gap-5 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
        {socialPlatforms.map((platform, index) => (
          <div key={platform.id} className="flex flex-col gap-2">
            <Label htmlFor={platform.id} className="text-sm font-semibold">
              {platform.name}
            </Label>
            <div className="relative group/social">
              <div 
                className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none z-10 transition-all group-focus-within/social:opacity-80"
                style={{ 
                  maskImage: `url(${platform.icon})`,
                  WebkitMaskImage: `url(${platform.icon})`,
                  maskSize: 'contain',
                  WebkitMaskSize: 'contain',
                  maskRepeat: 'no-repeat',
                  WebkitMaskRepeat: 'no-repeat',
                  maskPosition: 'center',
                  WebkitMaskPosition: 'center',
                  backgroundColor: getColor('primary')
                }}
              />
              <Input
                id={platform.id}
                type="text"
                value={socialLinks[index] || ''}
                onChange={(e) => handleLinkChange(index, e.target.value)}
                placeholder={`${platform.name} profile URL...`}
                className="!pl-10 !pr-3 !h-10 !py-2 transition-all"
              />
            </div>
          </div>
        ))}
      </div>
    </form>
  );
}

export default SocialLinks;
